import React, { useEffect, useState } from "react";

const DetailItem = ({
    label, value
}) => {
    return (
        <div>
            <div className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">{label}</div>
            <div className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{value || "-"}</div>
        </div>
    );
};

export default DetailItem;
